import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityFeatures = () => {
  const features = [
    {
      icon: 'Shield',
      label: 'SSL Encrypted',
      description: 'Your data is protected with industry-standard encryption'
    },
    {
      icon: 'Lock',
      label: 'Secure Storage',
      description: 'All credentials are securely hashed and stored'
    },
    {
      icon: 'CheckCircle2',
      label: 'Privacy First',
      description: 'We never share your personal information'
    }
  ];

  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
      {features?.map((feature, index) => (
        <div 
          key={index}
          className="flex flex-col items-center text-center p-4 rounded-lg bg-card border border-border"
        >
          <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-3">
            <Icon name={feature?.icon} size={24} color="var(--color-primary)" />
          </div>
          <h4 className="text-sm font-semibold text-foreground mb-1">
            {feature?.label}
          </h4>
          <p className="text-xs text-muted-foreground leading-relaxed">
            {feature?.description}
          </p>
        </div>
      ))}
    </div>
  );
};

export default SecurityFeatures;